(() => {
  if (window.AminoZCartAttributesLoaded) return;
  window.AminoZCartAttributesLoaded = true;

  const ROOT = window.Shopify?.routes?.root || '/';
  const ATTRIBUTE_KEY = 'az_mixed_backorder';
  const STATE_SELECTOR = '[data-az-mixed-backorder-state]';
  const CART_SECTION_EVENTS = [
    'action:cart:updateCart',
    'action:cart:updateCartandShowCart',
    'amino:samples:cart-changed'
  ];

  let timer = null;
  let syncInFlight = null;
  let queuedValue = null;

  const normaliseBooleanString = (value) =>
    String(value || '').trim().toLowerCase() === 'true' ? 'true' : 'false';

  const getStateFromDocument = () => {
    const states = Array.from(document.querySelectorAll(STATE_SELECTOR));
    if (!states.length) return null;

    return states.some((input) => normaliseBooleanString(input.value) === 'true')
      ? 'true'
      : 'false';
  };

  const getStateFromSections = (sections) => {
    if (!sections || typeof sections !== 'object') return null;

    for (const html of Object.values(sections)) {
      if (typeof html !== 'string' || !html.includes('data-az-mixed-backorder-state')) {
        continue;
      }

      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const stateInput = documentFragment.querySelector(STATE_SELECTOR);

      if (stateInput) return normaliseBooleanString(stateInput.value);
    }

    return null;
  };

  const fetchCart = async () => {
    const response = await fetch(`${ROOT}cart.js`, {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) throw new Error('Unable to retrieve the cart.');
    return response.json();
  };

  const updateCartAttribute = async (value) => {
    const response = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_KEY]: value
        }
      })
    });

    if (!response.ok) throw new Error('Unable to update the cart attribute.');
    return response.json();
  };

  const sync = async (requestedValue = null) => {
    const desiredValue = normaliseBooleanString(
      requestedValue ?? getStateFromDocument() ?? 'false'
    );

    if (syncInFlight) {
      queuedValue = desiredValue;
      return syncInFlight;
    }

    syncInFlight = (async () => {
      try {
        const cart = await fetchCart();
        const currentValue = normaliseBooleanString(
          cart?.attributes?.[ATTRIBUTE_KEY] ?? 'false'
        );

        if (currentValue !== desiredValue) {
          await updateCartAttribute(desiredValue);
        }
      } catch (error) {
        console.error('[Amino Z cart attributes]', error);
      } finally {
        syncInFlight = null;

        if (queuedValue !== null) {
          const nextValue = queuedValue;
          queuedValue = null;
          sync(nextValue);
        }
      }
    })();

    return syncInFlight;
  };

  const queueSync = (value = null) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => sync(value), 80);
  };

  CART_SECTION_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const sectionValue = getStateFromSections(event?.detail?.sections);
      queueSync(sectionValue);
    });
  });

  document.addEventListener('DOMContentLoaded', () => queueSync());
  window.addEventListener('pageshow', () => queueSync());
})();